<template>
  <div class="props-group">
      <div class="private">
        <el-form-item label="货币类型">
          <el-select v-model="component.properties.currencyType" placeholder="请选择">
            <el-option label="人民币" value="人民币"></el-option>
            <el-option label="美元" value="美元"></el-option>
          </el-select>
        </el-form-item>
      </div>
  </div>
</template>
<script>
export default {
  name: 'attr-currency-type',
  props: ['component']
}
</script>

<style lang="scss">
  .private {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/currency-type.vue